export const orderInWhichDrillholesShouldAppear: string[] = [
  "n",
  "h",
  "j",
  "e",
  "s",
  "r",
  "v_0",
  "v_1",
  "v_2",
  "lf",
  "dtw",
  "l",
  "o_noindex",
  "o_indexed",
  "pa",
];